export enum XeroPaymentTerms {
    daysAfterBillDate = 'DAYSAFTERBILLDATE',
    daysAfterBillMonth = 'DAYSAFTERBILLMONTH',
    ofCurrentMonth = 'OFCURRENTMONTH',
    ofFollowingMonth = 'OFFOLLOWINGMONTH'
}
